var React = require('react');

function Highways (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Layer_1","data-name":"Layer 1"},[React.createElement("path",{"d":"M1.24,7.56H15.8c-.49,4.24-3.41,8.32-7.28,9.48C4.64,15.88,1.73,11.8,1.24,7.56Z","key":0}),React.createElement("path",{"d":"M15.86,5.56H1.18a10.23,10.23,0,0,1,1-3.86h0a9.26,9.26,0,0,0,1.87.19c2,0,3.71-.07,4.44-.93.74.86,2.44.93,4.43.93a9.28,9.28,0,0,0,1.88-.19A10.42,10.42,0,0,1,15.86,5.56Z","key":1})]));
}

Highways.defaultProps = {"viewBox":"0 0 18 18"};

module.exports = Highways;

Highways.default = Highways;
